module.exports = __webpack_public_path__ + "img/Solutions-DebtAssist.f776f744.jpg";